export default (mountAutoComplete) =>
  mountAutoComplete({
    cocoonSelector: `[data-behaviour="groups-list-user"]`,
    path: () =>
      Silverfin.Routes.autocomplete_groups_path({
        firm_id: Silverfin.currentFirmId,
      }),
    textfieldSelector: '[data-behaviour="group-autocomplete"]',
  })
